import React from 'react';

export const DIGIT_BALL_KEYS = Array.from({ length: 5 }, (_, i) => `ball_${i + 1}`);
export const DIGIT_HEADERS = ['Digit', 'Overall', 'Ball1', 'Ball2', 'Ball3', 'Ball4', 'Ball5', 'Grand total'];

const DifferenceCell = ({ value, testId }) => (
  <td data-testid={testId} className={value > 0 ? 'text-emerald-700' : value < 0 ? 'text-red-700' : 'text-gray-600'}>
    {value == null ? '—' : `${value > 0 ? '+' : ''}${value.toFixed(2)}%`}
  </td>
);

export const DigitDifferenceMatrix = ({ data }) => (
  <section data-testid="digit-difference-section" className="space-y-3">
    <h2 className="text-base font-bold text-gray-900" data-testid="digit-difference-heading">Digit Difference Summary — Historical vs 2026</h2>
    <table className="digit-summary-matrix" data-testid="digit-difference-table">
      <thead><tr>{DIGIT_HEADERS.map((name, i) => <th key={name} scope="col" data-testid={`digit-difference-heading-${i}`}>{name}</th>)}</tr></thead>
      <tbody>{Array.from({ length: 10 }, (_, digit) => {
        const available = data?.hist_draws > 0 && data?.cy_draws > 0;
        const overall = available ? data.digit_stats?.find(row => row.digit === digit)?.diff : null;
        const balls = DIGIT_BALL_KEYS.map(key => available ? data.per_ball?.[key]?.find(row => row.digit === digit)?.diff : null);
        const total = balls.every(value => typeof value === 'number') ? Number(balls.reduce((sum, value) => sum + value, 0).toFixed(2)) : null;
        return <tr key={digit} data-testid={`digit-difference-row-${digit}`}>
          <th scope="row" data-testid={`digit-difference-digit-${digit}`}>{digit}</th>
          {[overall, ...balls, total].map((value, i) => <DifferenceCell key={i} value={value} testId={`digit-difference-${digit}-value-${i}`} />)}
        </tr>;
      })}</tbody>
    </table>
    <p className="text-xs text-gray-500" data-testid="digit-difference-definition">Difference = 2026 % − historical %. Grand total = Ball1 + Ball2 + Ball3 + Ball4 + Ball5 differences.</p>
  </section>
);
